import { Dropdown, Menu, Select, Switch } from 'antd';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Button } from '../../../baseComponents';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { Sort } from 'src/icons/Sort.icon';
import { useDispatch } from 'react-redux';
import {
  editSpecialtyAction,
  getAllSpecialtyListAction,
  getSpecialtyByIdAction as getSpecialtyByIdAction,
} from 'src/modules/SuperAdmin/store/actions/specialty.action';
import { useSelector } from 'react-redux';
import AddSpecialty from './AddSpecialty.page';
import DeleteSpecialty from './DeleteSpecialty.page';
import EditSpecialty from './EditSpecialty.page';

const Specialtypage = () => {
  const dispatch = useDispatch();

  const { getAllSpecialtiesList, dropdownSpecialties } = useSelector(
    (state) => state?.specialtyState
  );
  const { isLoading } = useSelector((state) => state?.conditionState);

  const [tableData, setTableData] = useState(null);
  const [specialtyDropdown, setSpecialtyDropdown] = useState([]);
  const [specialtyModalOpen, setSpecialtyModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [isfilterOn, setIsFilterOn] = useState(false);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    dispatch(getAllSpecialtyListAction());
  }, [dispatch]);

  useEffect(() => {
    if (
      getAllSpecialtiesList &&
      Array.isArray(getAllSpecialtiesList) &&
      getAllSpecialtiesList.length > 0
    ) {
      let dataArray = getAllSpecialtiesList?.map((list, index) => {
        return {
          key: index,
          specialty_id: list?.specialty_id,
          specialty_name: list?.specialty_name,
          isPublic: list?.is_public,
        };
      });
      if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
        setTableData(dataArray);
      }
    } else {
      setTableData([]);
    }
  }, [getAllSpecialtiesList]);

  useEffect(() => {
    if (dropdownSpecialties && Array.isArray(dropdownSpecialties)) {
      let dataArr = [];
      dropdownSpecialties.forEach((key) => {
        dataArr.push({
          value: key?.specialty_id,
          label: key?.specialty_name,
        });
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setSpecialtyDropdown(dataArr);
    }
  }, [dropdownSpecialties]);

  const handleEditSpecialty = (specialty_id) => {
    dispatch(getSpecialtyByIdAction(specialty_id, setEditModalOpen));
  };

  const handleDeleteSpecialty = (specialty_id) => {
    dispatch(getSpecialtyByIdAction(specialty_id, setDeleteModalOpen));
  };

  const menu_options = (specialty_id) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editSpecialty') {
            handleEditSpecialty(specialty_id);
          }

          if (key === 'deleteSpecialty') {
            handleDeleteSpecialty(specialty_id);
          }
        }}
      >
        <Menu.Item key="editSpecialty">
          <span className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit specialty</span>
          </span>
        </Menu.Item>
        <Menu.Item key="deleteSpecialty">
          <span className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove specialty</span>
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const specialty_nameSorter = (a, b) => {
    return a.specialty_name.localeCompare(b.specialty_name);
  };

  const handleRadioChange = (e, record) => {
    const payload = {
      specialty_name: record?.specialty_name,
      is_public: e,
    };
    dispatch(
      editSpecialtyAction(
        record?.specialty_id,
        payload,
        null,
        isfilterOn,
        selectedSpecialty
      )
    );
  };

  const columns = [
    {
      title: (
        <span className="font-[700]">
          {' '}
          Specialty name <Sort className={'sort-icon-doctor'} />
        </span>
      ),
      dataIndex: 'specialty_name',
      key: 'specialty_name',
      sorter: specialty_nameSorter,
    },
    {
      title: <span className="font-[700]"> Public</span>,
      dataIndex: 'public',
      key: 'public',
      render: (text, record) => {
        return (
          <>
            <div className="flex">
              <div className="mx-2">{record?.isPublic ? 'Yes' : 'No'}</div>
              <div className="">
                <Switch
                  value={record?.isPublic}
                  onChange={(e) => handleRadioChange(e, record)}
                />
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',

      render: (text, record) => {
        return (
          <Dropdown className="" overlay={menu_options(record?.specialty_id)}>
            <button
              type="button"
              className="p-0 bg-transparent border-none outline-none inline-flex"
            >
              <ActionMenuIcon />
            </button>
          </Dropdown>
        );
      },
    },
  ];

  const handleSelectChange = (e) => {
    if (e === 'All') {
      dispatch(getAllSpecialtyListAction());
      setIsFilterOn(false);
    } else {
      dispatch(getSpecialtyByIdAction(e, null, 'filter'));
      setIsFilterOn(true);
      setSelectedSpecialty(e);
    }
  };

  return (
    <>
      <div>
        <Formik>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="flex justify-between gap-4">
                <div className=" w-full xl:w-1/5 2xl:w-1/5 drop-shadow-sm bg-white rounded-xl practitioner-dropdown">
                  <Select
                    bordered={false}
                    className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
                    optionFilterProp="label"
                    placeholder="Search specialty"
                    options={specialtyDropdown}
                    showSearch
                    onChange={(e) => handleSelectChange(e)}
                    id="specialty"
                  ></Select>
                </div>
                <div className="">
                  <Button
                    type={'button'}
                    onClick={() => setSpecialtyModalOpen(true)}
                  >
                    <PlusIcon className={`mr-2`} /> Add specialty
                  </Button>
                </div>
              </div>
              <div className="mt-5 ant-table rounded-xl shadow-xl">
                <SuperAdminTable
                  className={`appointment-page-table`}
                  columns={columns}
                  data={tableData}
                  loading={tableLoader}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* Modals code added here */}
      <AddSpecialty
        isOpen={specialtyModalOpen}
        setIsOpen={setSpecialtyModalOpen}
        isfilterOn={isfilterOn}
        selectedSpecialty={selectedSpecialty}
      />

      <EditSpecialty
        isOpen={editModalOpen}
        setIsOpen={setEditModalOpen}
        isfilterOn={isfilterOn}
        selectedSpecialty={selectedSpecialty}
      />

      <DeleteSpecialty
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        isfilterOn={isfilterOn}
        selectedSpecialty={selectedSpecialty}
      />
      {/*  */}
    </>
  );
};

export default Specialtypage;
